import styled from "styled-components"

export const TabsContainer = styled.div`
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 480px) {
    padding: 32px 24px;
  }
`

export const TabsWrapper = styled.div`
  display: flex;
  height: 64px;
  justify-content: space-around;
  align-items: center;

  @media screen and (max-width: 480px) {
    width: 100%;
    justify-content: flex-start;
    white-space: nowrap;
    overflow: scroll;

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const Tab = styled.button`
  border: none;
  background: none;
  height: 56px;
  cursor: pointer;
  font-size: 16px;
  font-weight: ${({ active }) => (active ? "600" : "400")};
  color: ${({ active }) => (active ? "#202020" : "#565656")};
  outline: none;
  border-bottom: ${({ active }) => (active ? "1px solid #202020" : "")};
  margin-right: 32px;
`

export const ContentWrapper = styled.div`
  padding: 32px 0;
  width: 414px;

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`

export const Content = styled.div`
  width: 100%;
  display: ${({ active }) => (active ? "block" : "none")};
`

export const Label = styled.p`
  font-size: 14px;
  color: #565656;
`

export const Description = styled.p`
  font-size: 16px;
  color: #202020;
  padding-bottom: 24px;
`

export const ImageWrapper = styled.div`
  display: flex;
`

export const Img = styled.img`
  width: 100%;
  height: 100%;
`
